import { Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MethodsHelper} from '@app/helpers/methods.helper';
import {Branch} from '@app/models/branch';
import {Constants} from "@app/constants/constants";
import {TranslateService} from '@ngx-translate/core';
import {DepositAgreement} from "@app/models/deposit-agreement";

@Component({
    selector: 'app-deposit-detail-summary',
    templateUrl: './deposit-detail-summary.component.html',
    styleUrls: ['./deposit-detail-summary.component.css'],
    standalone: false
})
export class DepositDetailSummaryComponent implements OnInit, OnChanges {
    @Input() deposit: DepositAgreement;
    @Input() isDepositApproval: boolean;
    @Input() customerGroupId: string;
    @Input() branches: Array<Branch>;

    notesHierarchy: any[] = [];
    interestCalculationOptions = Constants.INTEREST_CALCULATION_OPTIONS;

    constructor(
        private translate: TranslateService
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.deposit && this.deposit) {
            // Process notes if needed
            this.notesHierarchy = [];
            if (this.deposit.notes && this.deposit.notes.length > 0) {
                // Populate notesHierarchy if required based on deposit.notes
            }
        }
    }

    ngOnInit(): void {
        if (!this.deposit) {
            this.deposit = new DepositAgreement();
        }
    }

    formatNumber(value) {
        if (value === null || value === undefined || isNaN(value)) return '';
        return MethodsHelper.numberWithCommas(value);
    }

    formatTextCapitalize(status: string) {
        if (!status) return '';
        return status.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
    }

    getDisplayStatus(): string {
        if (this.deposit?.workflowState === 'APPROVED'
            && ['FUNDED', 'MATURED', 'CLOSING', 'CLOSED'].includes(this.deposit?.businessState)) {
            return this.deposit.businessState;
        }
        return this.deposit?.workflowState;
    }

    depositPeriodCovertToString() {
        if (!this.deposit || !this.deposit.periodDays) return '';
        return this.deposit.periodDays + ' days';
    }

    findInterestCalculationOptions(interestCalculationOption: string) {
        if (!interestCalculationOption) return '';
        let option = this.interestCalculationOptions.find(opt => opt.value === interestCalculationOption);
        return option ? option.label : interestCalculationOption;
    }

    getBranchName(branchCode: string) {
        if (!branchCode || !this.branches) return branchCode || '';
        let branch = this.branches.find(b => b.code === branchCode);
        return branch?.name;
    }
}
